export type IncompleteBuildPromptResult = {
  incomplete: boolean;
  reason: string | null;
};

const unfinishedEndingPatterns: Array<{ pattern: RegExp; reason: string }> = [
  {
    pattern: /the app is ready for handover only when\s*:\s*$/i,
    reason: "handover criteria lead-in has no following content",
  },
  {
    pattern: /(?:^|\n)\s*(?:#{1,6}\s*)?sign[- ]off criteria\s*:?\s*$/i,
    reason: "Sign-Off Criteria has no following content",
  },
  {
    pattern: /(?:^|\n)\s*(?:#{1,6}\s*)?final delivery requirements\s*:?\s*$/i,
    reason: "Final Delivery Requirements has no following content",
  },
  {
    pattern: /the readme must include\s*:\s*$/i,
    reason: "README requirements lead-in has no following content",
  },
  {
    pattern: /the final app must document\s*:\s*$/i,
    reason: "final documentation lead-in has no following content",
  },
  {
    pattern: /(?:include|includes|including|as follows|the following)\s*:?\s*$/i,
    reason: "final line indicates missing continuation content",
  },
];

export function detectIncompleteBuildPrompt(prompt: string): IncompleteBuildPromptResult {
  const trimmed = prompt.trim();
  if (!trimmed) {
    return { incomplete: true, reason: "Build Prompt text is empty" };
  }

  for (const candidate of unfinishedEndingPatterns) {
    if (candidate.pattern.test(trimmed)) {
      return { incomplete: true, reason: candidate.reason };
    }
  }

  const finalLine = trimmed.split(/\r?\n/).at(-1)?.trim() ?? "";
  if (finalLine.endsWith(":")) {
    return {
      incomplete: true,
      reason: "final line ends with a colon and has no following content",
    };
  }

  const bareMarkdownHeading = /^#{1,6}\s+[^#]+$/i.test(finalLine);
  const bareAllCapsHeading = finalLine.length >= 5 && /^[A-Z][A-Z0-9 &:/-]+$/.test(finalLine);
  if (bareMarkdownHeading || bareAllCapsHeading) {
    return {
      incomplete: true,
      reason: "final heading has no following content",
    };
  }

  return { incomplete: false, reason: null };
}
